export const sendRecordOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: "200",
    labelWidth: "150",
    defaultSort: {
      prop: "createTime",
      order: "descending",
    },
    column: [
      {
        label: "优惠券名称",
        prop: "name",
        type: "input",
        // search: true,
        span: 13,
        placeholder: "请选择客户端类型",
      },
      {
        label: "店铺名称",
        prop: "shopName",
        type: "input",
        // search: true,
        span: 13,
        placeholder: "请输入优惠券",
      },
      {
        label: "发放时间",
        prop: "createTime",
        type: "date",
        // search: true,
        span: 13,
        format: "yyyy-MM-dd:HH:mm:ss",
        valueFormat: "yyyy-MM-dd:HH:mm:ss",
        pickerOptions: {
          disabledDate: (time) => {
            return time.getTime() > Date.now();
          },
        },
      },
      {
        label: "状态",
        prop: "status",
        type: "select",
        // search: true,
        span: 13,
        dicData: [
          {
            label: "未使用",
            value: "NOT_USED",
          },
          {
            label: "已使用",
            value: "USED_ALREADY"
          },
          {
            label: "已过期",
            value: "EXPIRED"
          },
        ],
      },
    ],
  };
  